import React, {Component} from 'react';
import GroupedFields from "~/ui/GroupedFields/GroupedFields";
import css from './css.css';
import cn from 'classnames';
import { extractSpacingProps } from '~/native-ui';
import { connectedFilterFields } from '~/ui/Filters';


export class OtherFilterFields extends Component {
    static propTypes = {};

    render() {
        const filteredRecords = this.props.recordsFilter ? this.props.recordsFilter(this.props.filterNames) : this.props.filterNames;
        const [spacingProps] = extractSpacingProps(this.props);

        return <GroupedFields
            className={cn(css.moreFilterContainer, this.props.className)}
            modelId={this.props.modelId}
            captions={this.props.captions}
            fieldNames={filteredRecords}
            type="filter"

            captionRowClassName={css.captionRow}
            elementColClassName={css.filterCol}
            rowClassName={css.filterRow}
            { ...spacingProps }
            xs={1}
        />
    }
}

const RXOtherFilterFields = connectedFilterFields()(OtherFilterFields);

export default RXOtherFilterFields;